<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 搜索区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="商品/条码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商品名称或条码查询" v-model="queryParam.search"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tree-select
                    style="width: 100%"
                    :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    allow-clear
                    :treeData="categoryTree"
                    v-model="queryParam.categoryId"
                    placeholder="请选择分类">
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select style="width: 100%" allow-clear placeholder="只看该等级已设价" v-model="queryParam.levelId">
                    <a-select-option v-for="lv in levels" :key="lv.id" :value="lv.id">{{ lv.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" style="margin-top: 8px">
              <a-col :md="8" :sm="24">
                <a-checkbox v-model="queryParam.onlySet">只看已设置</a-checkbox>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAddItems">添加商品</a-button>
          <a-button icon="download" @click="handleDownloadTemplate">导入模板下载</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" icon="import" @click="handleImportClick">导入</a-button>
          <a-button v-if="btnEnableList.indexOf(3)>-1" icon="export" @click="handleExport">导出</a-button>
        </div>
        <a-table
          size="middle"
          bordered
          rowKey="materialId"
          :columns="materialColumns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :expandedRowKeys="expandedRowKeys"
          @expandedRowsChange="onExpand"
          @change="handleTableChange">
          <span slot="action" slot-scope="text, record">
            <a v-if="btnEnableList.indexOf(1)>-1" @click="handleSaveRow(record)">保存</a>
            <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="移除后该商品全部等级价删除，回退零售价取价，确定？" @confirm="() => handleRemoveItem(record.materialId)">
              <a>移除</a>
            </a-popconfirm>
          </span>
          <template slot="discountSlot" slot-scope="text, record">
            <a-switch
              size="small"
              :checked="!record.discountExcluded"
              checkedChildren="享受"
              unCheckedChildren="排除"
              @change="(v) => handleDiscountFlag(record, v)" />
          </template>
          <template slot="expandedRowRender" slot-scope="record">
            <a-table
              size="small"
              bordered
              rowKey="extendId"
              :columns="unitColumns"
              :dataSource="record.units"
              :pagination="false">
              <template v-for="lv in levels" :slot="'price_' + lv.id" slot-scope="text, unit">
                <a-input-number :key="'input_' + lv.id + '_' + unit.extendId"
                  size="small" style="width:100%" :min="0" :precision="2"
                  :value="editValue(unit.extendId, lv.id)"
                  @change="(v) => setEdit(unit.extendId, lv.id, v)" />
              </template>
            </a-table>
          </template>
        </a-table>
        <!-- 商品选择弹窗 -->
        <j-select-material-modal ref="selectModal" :multi="true" @ok="selectOK"></j-select-material-modal>
        <!-- 导入弹窗 -->
        <a-modal title="导入会员价（CSV）" :visible="importVisible" :footer="null" @cancel="importVisible = false" width="760px">
          <a-alert type="info" showIcon style="margin-bottom:12px"
            message="文件格式：商品条码,等级名称,会员价（空=清除该等级价）,单位,等级折扣(1=排除)。先下载模板查看样例。" />
          <input type="file" accept=".csv" @change="onImportFile" style="margin-bottom:12px" />
          <template v-if="importPreview">
            <a-row :gutter="8" style="margin-bottom:8px">
              <a-col :span="6">新增：{{ importPreview.adds.length }}</a-col>
              <a-col :span="6">更新：{{ importPreview.updates.length }}</a-col>
              <a-col :span="6">清除：{{ importPreview.removes.length }}</a-col>
              <a-col :span="6" style="color:red">错误：{{ importPreview.errors.length }}</a-col>
            </a-row>
            <div style="max-height:260px;overflow:auto;border:1px solid #e8e8e8;padding:8px">
              <div v-for="item in importPreview.errors" :key="'e' + item.line" style="color:red">第 {{ item.line }} 行：{{ item.message }}</div>
              <div v-for="item in importPreview.adds" :key="'a' + item.line">第 {{ item.line }} 行：新增 {{ item.barcode }} {{ item.levelName }} = {{ item.price }} <span v-if="item.warn" style="color:orange">（{{ item.warn }}）</span></div>
              <div v-for="item in importPreview.updates" :key="'u' + item.line">第 {{ item.line }} 行：更新 {{ item.barcode }} {{ item.levelName }} = {{ item.price }} <span v-if="item.warn" style="color:orange">（{{ item.warn }}）</span></div>
              <div v-for="item in importPreview.removes" :key="'r' + item.line">第 {{ item.line }} 行：清除 {{ item.barcode }} {{ item.levelName }}</div>
            </div>
            <a-button type="primary" style="margin-top:12px" :disabled="importPreview.adds.length + importPreview.updates.length + importPreview.removes.length === 0"
              :loading="importLoading" @click="confirmImport">确认导入</a-button>
          </template>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import JSelectMaterialModal from '@/components/jeecgbiz/modal/JSelectMaterialModal'
import { priceList, priceAddItems, priceRemoveItem, priceSaveBatch, priceDiscountFlag, priceImport } from '@/api/plugin/member'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'

export default {
  name: 'MemberPriceList',
  mixins: [JeecgListMixin],
  components: {
    JSelectMaterialModal
  },
  data() {
    return {
      // 按钮权限匹配键，须与菜单URL一致（JeecgListMixin.initActiveBtnStr 按 urlPath 匹配 winBtnStrList）
      urlPath: '/plugin/member/price',
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      queryParam: { search: '', categoryId: undefined, levelId: undefined, onlySet: false },
      levels: [],
      categoryTree: [],
      edits: {},
      expandedRowKeys: [],
      importVisible: false,
      importPreview: null,
      importContent: '',
      importLoading: false,
      materialColumns: [
        { title: '商品名称', dataIndex: 'materialName' },
        { title: '单位行数', dataIndex: 'units', width: 100, align: 'center', customRender: (t) => (t ? t.length : 0) },
        { title: '等级折扣', dataIndex: 'discountExcluded', width: 110, align: 'center', scopedSlots: { customRender: 'discountSlot' } },
        { title: '操作', dataIndex: 'action', width: 140, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/member/prices'
      }
    }
  },
  computed: {
    unitColumns() {
      const cols = [
        { title: '条码', dataIndex: 'barCode', width: 140 },
        { title: '单位', dataIndex: 'unit', width: 80 },
        { title: '规格', dataIndex: 'sku', width: 100 },
        { title: '零售价', dataIndex: 'retailPrice', width: 90, align: 'right' }
      ]
      for (const lv of this.levels) {
        cols.push({
          title: lv.name,
          dataIndex: 'price_' + lv.id,
          width: 120,
          align: 'right',
          scopedSlots: { customRender: 'price_' + lv.id }
        })
      }
      return cols
    }
  },
  created() {
    this.loadCategoryTree()
  },
  methods: {
    loadCategoryTree() {
      getAction('/materialCategory/getMaterialCategoryTree', { id: '' }).then(res => {
        this.categoryTree = res || []
      })
    },
    loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      priceList({
        search: this.queryParam.search,
        categoryId: this.queryParam.categoryId,
        levelId: this.queryParam.levelId,
        onlySet: this.queryParam.onlySet === true,
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }).then((res) => {
        this.loading = false
        if (res.code === 200) {
          this.dataSource = res.data.rows
          this.ipagination.total = res.data.total
          this.levels = res.data.levels || []
          this.edits = {}
          // 预填已配价格 + 展开全部商品行
          this.expandedRowKeys = []
          for (const row of this.dataSource) {
            this.expandedRowKeys.push(row.materialId)
            for (const unit of row.units) {
              for (const lv of this.levels) {
                const key = unit.extendId + '_' + lv.id
                const val = unit.prices ? unit.prices[String(lv.id)] : null
                this.$set(this.edits, key, val === null || val === undefined ? null : parseFloat(val))
              }
            }
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    onExpand(expandedKeys) {
      this.expandedRowKeys = expandedKeys
    },
    editValue(extendId, levelId) {
      const v = this.edits[extendId + '_' + levelId]
      return v === undefined ? null : v
    },
    setEdit(extendId, levelId, v) {
      this.$set(this.edits, extendId + '_' + levelId, v)
    },
    handleAddItems() {
      this.$refs.selectModal.showModal()
    },
    selectOK(rows, idstr) {
      if (!idstr) {
        return
      }
      const ids = idstr.split(',').filter((s) => s).map(Number)
      if (!ids.length) {
        return
      }
      priceAddItems(ids).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData(1)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleSaveRow(record) {
      const items = []
      for (const unit of record.units) {
        for (const lv of this.levels) {
          const key = unit.extendId + '_' + lv.id
          const original = unit.prices ? unit.prices[String(lv.id)] : null
          const originalVal = original === null || original === undefined ? null : parseFloat(original)
          const current = this.edits[key] === undefined ? null : this.edits[key]
          if (current === originalVal) {
            continue // 未变化不提交
          }
          items.push({ extendId: unit.extendId, levelId: lv.id, price: current })
        }
      }
      if (!items.length) {
        this.$message.info('没有修改需要保存')
        return
      }
      priceSaveBatch(items).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleRemoveItem(materialId) {
      priceRemoveItem(materialId).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData(1)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    /** 等级折扣开关：ON=享受零售价×等级折扣率，OFF=加入排除清单（按零售价取价） */
    handleDiscountFlag(record, enjoy) {
      priceDiscountFlag(record.materialId, !enjoy).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$set(record, 'discountExcluded', !enjoy)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleDownloadTemplate() {
      const header = '商品条码,等级名称,会员价,单位,等级折扣(排除=1)\r\n'
      const blob = new Blob(['\uFEFF' + header], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '会员价导入模板.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
    handleExport() {
      window.location.href = window._CONFIG['domianURL'] + '/api/plugin/member/prices/export'
    },
    handleImportClick() {
      this.importVisible = true
      this.importPreview = null
      this.importContent = ''
    },
    onImportFile(e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }
      const that = this
      const reader = new FileReader()
      reader.onload = function() {
        that.importContent = reader.result
        priceImport(that.importContent, true).then((res) => {
          if (res.code === 200) {
            that.importPreview = res.data
          } else {
            that.$message.warning(res.message)
          }
        })
      }
      reader.readAsText(file, 'UTF-8')
      e.target.value = ''
    },
    confirmImport() {
      this.importLoading = true
      priceImport(this.importContent, false).then((res) => {
        if (res.code === 200) {
          this.$message.success('导入完成，写入 ' + res.data.written + ' 条')
          this.importVisible = false
          this.loadData(1)
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.importLoading = false
      })
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.table-operator { margin-bottom: 15px; }
</style>
